import { useEffect, useRef, useState } from 'react';

// Real pixel width of a container via ResizeObserver, so an SVG's viewBox can
// match its rendered size 1:1 instead of stretching (which warps text). Same
// hook as the forecast chart in chat-blocks/TimeSeriesForecastBlock.jsx.
export default function useContainerWidth(initial = 600) {
  const ref = useRef(null);
  const [width, setWidth] = useState(initial);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const measure = () => {
      const w = el.clientWidth;
      if (w) setWidth((prev) => (Math.round(w) !== Math.round(prev) ? w : prev));
    };
    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  return [ref, width];
}
